const API_CACHE_MARKER = "-api-";

/**
 * Удаляет кеш справочников, который ведёт service worker (`global-api.ts`).
 * Нужен при выходе и потере сессии: кеш общий для браузера, и без очистки
 * следующий пользователь увидел бы данные предыдущего, пока сеть недоступна.
 * Ошибки глушатся — очистка кеша не должна мешать выходу.
 */
export async function clearApiCache(): Promise<void> {
  if (typeof caches === "undefined") {
    return;
  }
  try {
    const names = await caches.keys();
    await Promise.all(
      names
        .filter((name) => name.includes(API_CACHE_MARKER))
        .map((name) => caches.delete(name))
    );
  } catch (error) {
    console.warn("clearApiCache: failed to clear API cache", error);
  }
}
